(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/react-dialog-wrapper/assets/javascripts/helper.js') >= 0) return;  svs.modules.push('/components/content/react-dialog-wrapper/assets/javascripts/helper.js');
"use strict";


const dialog = svs.ui.dialog;

const button = _ref => {
  let title = _ref.title,
    callback = _ref.callback;
  return {
    title,
    callback: callback ? callback : () => {}
  };
};
const injectToButtonCallbacks = (buttons, closeDialog) => {
  buttons.forEach(button => {
    const theCallback = button.callback;
    button.callback = (dialog, form) => {
      closeDialog();
      theCallback(dialog, form);
    };
  });
  return buttons;
};

const checkbox = _ref2 => {
  let checked = _ref2.checked,
    text = _ref2.text,
    value = _ref2.value;
  return {
    checked: typeof checked === 'boolean' ? checked : false,
    text: text || '',
    type: dialog.message.CHECKBOX,
    value: typeof value === 'boolean' ? value : false
  };
};

const cmsType = {
  CONFIRM: 'confirm',
  ERROR: 'error',
  INFO: 'info',
  DEFAULT: 'default'
};

const icon = {
  [cmsType.CONFIRM]: 'checkmark',
  [cmsType.ERROR]: 'exclamation-sign',
  [cmsType.INFO]: 'information',
  [cmsType.DEFAULT]: 'information'
};

const newDialog = _ref3 => {
  let area = _ref3.area,
    autoClose = _ref3.autoClose,
    buttons = _ref3.buttons,
    convertToPopup = _ref3.convertToPopup,
    icon = _ref3.icon,
    message = _ref3.message,
    title = _ref3.title,
    type = _ref3.type;
  const theDialog = new dialog.Confirm({
    actions: injectToButtonCallbacks(buttons, () => theDialog.close()),
    area: area || dialog.area.POPUP,
    autoClose: autoClose || 0,
    branding: "cms dialog-branding-cms-type-".concat(type || 'default'),
    convertToPopup: convertToPopup || false,
    icon,
    message: message || [],
    title
  });
  dialog.api.add(theDialog);
  autoClose && setTimeout(() => theDialog.close(), autoClose);
  if (theDialog.el.parentNode) {
    const outmostElement = theDialog.el.parentNode.parentNode;
    outmostElement.classList.add('dialog-branding-cms-outmost');
    if (area) {
      theDialog.el.classList.add("dialog-branding-cms-".concat(area));
      outmostElement.classList.add("dialog-branding-cms-outmost-area-".concat(area));
    }
  }
  return theDialog;
};

const text = _ref4 => {
  let text = _ref4.text;
  return {
    text,
    type: dialog.message.TEXT
  };
};

const helper = {
  button,
  checkbox,
  cmsType,
  icon,
  newDialog,
  text
};
svs.components.dialogWrapper.helper = helper;

 })(window);